import React from "react";
import Image from "next/image";
import { homeLogos } from "./images";

type Props = object;

function Logos({}: Props) {
  const logos = Object.values(homeLogos);

  return (
    <section id="tools" className="mx-auto w-full max-w-6xl px-4">
      <p className="text-muted-foreground mb-8 text-center">
        Works with your favourite tools and many more
      </p>

      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-4 sm:gap-6 md:gap-8">
        {logos.map((src, idx) => (
          <div
            key={`logo-${idx}`}
            className="flex items-center justify-center p-2 opacity-70"
          >
            <Image
              src={src}
              alt="logo"
              width={80}
              height={32}
              className="h-8 w-auto object-contain"
            />
          </div>
        ))}
      </div>
    </section>
  );
}

export default Logos;
